/* eslint-disable max-len */
import { ActiveDashboard } from './constants';

export const activeDashboardRequest = (data, callback) => ({ type: ActiveDashboard.activeDahsboardRequest, data, callback });
export const activeDashboardSuccess = (data) => ({ type: ActiveDashboard.activeDahsboardSuccess, data });

export const fetchDashboardDataRequest = (data, callback) => ({ type: ActiveDashboard.fetchDashboardDataRequest, data, callback });
export const fetchDashboardDataSuccess = (data) => ({ type: ActiveDashboard.fetchDashboardDataSuccess, data });

export const removeChartFromDashboardRequest = (data, callback) => ({ type: ActiveDashboard.removeChartFromDashboardRequest, data, callback });
export const removeChartFromDashboardSuccess = (data) => ({ type: ActiveDashboard.removeChartFromDashboardSuccess, data });

export const updateDashboardRequest = (data, callback) => ({ type: ActiveDashboard.updateDashboardRequest, data, callback });
export const updateDashboardSuccess = (data) => ({ type: ActiveDashboard.updateDashboardSuccess, data });

export const refetchDashboardDataRequest = (data, callback) => ({ type: ActiveDashboard.refetchDashboardDataRequest, data, callback });
export const refetchDashboardDataSuccess = (data) => ({ type: ActiveDashboard.refetchDashboardDataSuccess, data });

